<template>
  <h1>QAList</h1>
</template>

<script>
export default {
  name: "QAList"
};
</script>

<style></style>
